import { authenticatedGet, authenticatedPatch, authenticatedDelete } from "../../api/authenticatedFetch";

const BASE = "/api/v1/assistant";

export async function listConversations() {
  const j = await authenticatedGet(`${BASE}/conversations`);
  return j.conversations || [];
}

export async function getConversation(id) {
  return authenticatedGet(`${BASE}/conversations/${id}`); // { conversation, messages }
}

export async function patchConversation(id, body) {
  const j = await authenticatedPatch(`${BASE}/conversations/${id}`, body);
  return j.conversation;
}

export async function deleteConversation(id) {
  return authenticatedDelete(`${BASE}/conversations/${id}`);
}
